export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ22.05ce2788.mp3";